import React, { useState } from "react";
import {
    BottomControlBar,
    BottomControls,
    ControlLabel,
    RoundControl
} from "src/scenes/Chat/components/ChatCallPanel.styled";
import MediaIcon from "./MediaIcon";
import StandardModal, { StandardModalActionButton, StandardModalActionGroup } from "src/components/StandardModal";
import {
    SCREEN_SHARE_CONFIRMATION,
    SCREEN_SHARE_TAKEOVER_CONFIRMATION
} from "src/scenes/Chat/services/ScreenShareHandover";

const LiveCallControls = ({
    backgroundIsActive,
    localAudioIsEnabled,
    localVideoIsEnabled,
    onHangup,
    onToggleAudio,
    onToggleBackgrounds,
    onToggleScreenShare,
    onToggleSettings,
    onToggleMeeting,
    onToggleVideo,
    overlayPanel = null,
    screenShareIsActive,
    remoteScreenShareIsActive
}) => {
    const [confirmationWindow, setConfirmationWindow] = useState(null);
    const closeConfirmation = () => setConfirmationWindow(null);

    return (
        <BottomControlBar>
            {overlayPanel}
            <BottomControls aria-label="Call controls">
                {onToggleMeeting && (
                    <RoundControl
                        type="button"
                        title="Invite people and manage guests"
                        data-call-overlay-toggle="true"
                        onClick={onToggleMeeting}
                    >
                        <ControlLabel>Invite</ControlLabel>
                    </RoundControl>
                )}
                <RoundControl
                    type="button"
                    title={localAudioIsEnabled ? "Mute microphone" : "Unmute microphone"}
                    $active={localAudioIsEnabled}
                    onClick={onToggleAudio}
                >
                    <MediaIcon type="mic" disabled={!localAudioIsEnabled} />
                </RoundControl>
                <RoundControl
                    type="button"
                    title={localVideoIsEnabled ? "Turn camera off" : "Turn camera on"}
                    $active={localVideoIsEnabled}
                    onClick={onToggleVideo}
                >
                    <MediaIcon type="video" disabled={!localVideoIsEnabled} />
                </RoundControl>
                <RoundControl
                    type="button"
                    title={screenShareIsActive ? "Stop sharing screen" : "Share screen"}
                    $active={screenShareIsActive}
                    onClick={event => {
                        const gestureWindow = event.currentTarget.ownerDocument.defaultView;
                        if (screenShareIsActive) {
                            onToggleScreenShare(gestureWindow);
                        } else {
                            setConfirmationWindow(gestureWindow);
                        }
                    }}
                >
                    <MediaIcon type="screen" disabled={false} />
                </RoundControl>
                <RoundControl
                    type="button"
                    title="Backgrounds and effects"
                    data-call-overlay-toggle="true"
                    $active={backgroundIsActive}
                    onClick={onToggleBackgrounds}
                >
                    <MediaIcon type="background" disabled={false} />
                </RoundControl>
                <RoundControl
                    type="button"
                    title="Call settings"
                    data-call-overlay-toggle="true"
                    onClick={onToggleSettings}
                >
                    <MediaIcon type="settings" disabled={false} />
                </RoundControl>
                <RoundControl
                    type="button"
                    title="Leave call"
                    $danger
                    onClick={onHangup}
                >
                    <ControlLabel>Leave</ControlLabel>
                </RoundControl>
            </BottomControls>
            <StandardModal
                open={Boolean(confirmationWindow)}
                container={confirmationWindow?.document.body}
                onClose={closeConfirmation}
                widthMode="small"
                title={remoteScreenShareIsActive ? "Take over screen sharing" : "Share your screen"}
                description={remoteScreenShareIsActive ? SCREEN_SHARE_TAKEOVER_CONFIRMATION : SCREEN_SHARE_CONFIRMATION}
                footer={(
                    <StandardModalActionGroup>
                        <StandardModalActionButton type="button" onClick={closeConfirmation}>
                            Cancel
                        </StandardModalActionButton>
                        <StandardModalActionButton
                            type="button"
                            $variant="primary"
                            onClick={event => {
                                // Invoke capture during this new click, before closing the modal
                                // or yielding to any asynchronous permission or handover work.
                                onToggleScreenShare(event.currentTarget.ownerDocument.defaultView);
                                closeConfirmation();
                            }}
                        >
                            {remoteScreenShareIsActive ? "Take over" : "Share screen"}
                        </StandardModalActionButton>
                    </StandardModalActionGroup>
                )}
            />
        </BottomControlBar>
    );
};

export default LiveCallControls;
